/** @format */

import {styled} from '@mui/material/styles';

const PREFIX = 'ErrorSettings';

export const classes = {
  subTitle: `${PREFIX}-subTitle`,
  secondaryText: `${PREFIX}-secondaryText`,
  sensorSettingsText: `${PREFIX}-sensorSettingsText`,
  link: `${PREFIX}-link`,
  moreLessLink: `${PREFIX}-moreLessLink`,
  removeIcon: `${PREFIX}-removeIcon`,
  checkbox: `${PREFIX}-checkbox`,
  exceptionValue: `${PREFIX}-exceptionValue`,
  multyInput: `${PREFIX}-multyInput`,
  removeButton: `${PREFIX}-removeButton`,
  removeButtonIcon: `${PREFIX}-removeButtonIcon`,
};

export const Root = styled('div')(({theme}) => ({
  [`& .${classes.subTitle}`]: {
    color: '#F1F1F1',
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '160%',
    letterSpacing: '0.15px',
  },

  [`& .${classes.secondaryText}`]: {
    color: '#A1A1A1',
  },

  [`& .${classes.sensorSettingsText}`]: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '22px',
  },

  [`& .${classes.link}`]: {
    textDecoration: 'underline',
    verticalAlign: 'baseline',
  },

  [`& .${classes.moreLessLink}`]: {
    color: theme.palette.success.main,
    fontWeight: 700,
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
      textDecorationColor: theme.palette.success.main,
    },
  },

  [`& .${classes.removeIcon}`]: {
    padding: theme.spacing(1),
  },

  [`& .${classes.checkbox}`]: {
    color: 'rgba(255, 255, 255, 0.7)',
  },

  [`& .${classes.exceptionValue}`]: {
    lineBreak: 'anywhere',
  },

  [`& .${classes.multyInput}`]: {
    display: 'flex',
    width: '350px',
    marginTop: theme.spacing(2),
  },
  [`& .${classes.removeButton}`]: {
    minWidth: '16px',
    width: '16px',
    height: '16px',
  },
  [`& .${classes.removeButtonIcon}`]: {
    color: '#4D4E4E',
    fontSize: '16px',
  },
}));
